export const m = {
    //ytlogin.vue
    LoginError: '登录失败，请重新登录！',
    //resetpassword2.vue
    ForgetPassword: '忘记密码',
    PlsEnterToken: '请输入token',
    PlsEnterNewPassword: '请输入新密码',
    PlsDoubleEnterNewPassword: '请再次输入新密码',
    OKBtn: '确认',
    ModifySuccessful: '修改成功',
    PassModifyFailTokenError: '密码修改失败，token错误',
    NetworkErrorPassModifyFail: '网络错误，密码修改失败',
    TwoTimePassNotEqual: '二次密码输入不一样',
    PlsEnterAllInfo: '请输入完整信息',
    //resetpassword.vue
    PlsEnterOldPassword: '请输入旧密码',
    ResetPass: '重置密码',
    ModifyPassFail: '密码修改失败',
    //register.vue
    Register: '注册',
    PlsEnterMobileEmailLoginName: '请输入手机号/邮箱/登录名',
    PlsEnterPass: '请输入密码',
    PlsEnterPassAgain: '请再次输入密码',
    RegisterOK: '注册成功',
    TwicePassNotSame: '二次输入密码不相同',
    PlsFillAllInfo: '请填入完整信息',
    //login.vue
    //OKBtn: '请输入手机号/邮箱/登录名',    
    Login: '登录',
    QuickRegister: '快速注册',
    ForgetPass: '忘记密码？',
    NoPermission: '暂无获得权限',
    //forgetpassword.vue
    PlsEnterCheckEmail: '请输入验证邮箱',
    Send: '发送',
    EmailSendOK: '邮件发送成功',
    PlsEnterRightEmail: '请输入正确的邮箱',
    //header.vue
    HomePage: '主页',
    PlanMeeting: '安排会议',
    ControlMeeting: '控制会议',
    ScanCodeCheckin: '扫码签到',
    MofifyPass: '修改密码',
    PersonProfile: '个人资料',
    ChangeSkin: '换肤',
    Help: '帮助',
    Exit: '退出',
    //forthcomeing_meeting.vue
    ListOfUpcomingMeetings: '即将举行会议列表',
    AfterYear: '年后',
    AfterMonth: '月后',
    AfterDay: '天后',
    AfterHour: '小时后',
    AfterMinute: '分后',
    BeforeYear: '年前',
    BeforeMonth: '月前',
    BeforeDay: '天前',
    BeforeHour: '小时前',
    BeforeMinute: '分前',
    NowNoPlanMeetingList: '目前没有安排会议列表',
    //forthmeetingvmr.vue
    NowMeetingList: '正在举行会议列表',
    //OKBtn: '目前没有安排会议列表',
    YouNoRight: '您尚无此权限！',
    //historymeeting.vue
    HistoryMeetingList: '历史举行会议列表',
    //OKBtn: '年后',
    //OKBtn: '目前没有安排会议列表',
    MeetingListGetError: '会议列表获取错误',
    //historyplaymeeting.vue
    HistoryMeetingLiveList: '历史会议点播列表',
    //meetingtemplate.vue
    MeetingTemplateList: '会议模板列表',
    PlsEnterMeetingTemplateName: '请输入会议模板名称',
    DeleteConfirmation: '删除确认',
    YouConfirmaDelete: '您是否确定删除',
    Template: '模板吗？',
    CancelBtn: '取消',
    //OKBtn: '确定',   
    DeleteMeetingTemplateFail: '删除会议模板失败',
    //OKBtn: '会议列表列表获取错误',
    //meetingtemplate_edit.vue
    MeetingTemplateDetail: '会议模板详情',
    TemplateName: '模板名称',
    PlsEnterTemplateName: '请输入模板名称',
    MeetingName: '会议名称',
    PlsEnterMeeetingNO: '请输入会议号码',
    MeetingType: '会议类型',

    InstantConference: '即时会议',
    ReservedConference: '预约会议',
    MeetingIntroduce: '会议介绍',
    PlsEnterMeetingIntroduce: '请输入会议介绍',
    Participants: '与会人员',
    ConferenceTerminal : '与会终端',
    ConferenceHost: '与会主持',
    ConferenceRecord: '会议录制',
    ConferenceLive: '会议直播',
    ModifyBtn: '修改',
    Meeting: '会议',
    ModifyOK: '修改成功！',
    MeetingNameNotNull: '会议名称不能为空',
    OperateFail: '操作失败',
    //pdf.vue
    PrePage: '上一页',
    NextPage: '下一页',
    //list.vue
    SelectAll: '全选',
    SelectZero: ',已选:0人',
    CompanyName: '公司名称',
    Connector: '联系人',
    //attendmeeting.vue
    ScheduleMeetingList: '安排会议列表',
    //OKBtn: '安排会议',
    //Connector: '联系人',
    NewMeeting: '新建会议',
    PersonTemplate: '个人模板',
    RecentHistoryConference: '最近历史会议',
    ConferenceNo: '会议号码',
    PlsEnterConferenceNo: '请输入会议号码',
    RandomMeetingNo: '随机会号',
    //OKBtn: '会议名称',
    PlsEnterMeetingName: '请输入会议名称',
    PlsEnterMeetingPassword: '请输入会议密码',
    MeetingPassword: '会议密码',
    HidePassword: '隐藏密码',
   // OKBtn: '即时会议',
   // OKBtn: '预约会议',
    MeetingDate: '会议日期',
    SelectDate: '选择日期',
    MeetingTime: '会议时间',
    //OKBtn: '会议日期',
    MeetingDuration: '会议时长',
    //MeetingIntroduce: '会议介绍',
    PlsEnterMeetingIntroduce: '请输入会议介绍',
   // Participants: '与会人员',
   // OKBtn: '与会终端',会议主持 会议录制 会议直播
    Appointment: '预约',
    NewBtn: '新建',
    Successful: '成功',
    MeetingNo: '会议号:',
    PlsAttendOnTime: '请准时参加！',
    MeetingNameNotNull: '会议名称不能为空',
    MeetingNameToLong: '会议名称太长(需小于15个字符)',
    MeetingPasswordFormatError: '会议密码格式错误',
    PlsFillDateTime: '请填写会议日期和时间',
    AppointTimeShoudBigThanNow: '预约时间至少大于当前时间15分钟',
    //attendmeetinglist.vue
    MeetingNoticeColon: '会议通知:',
    MeetingNoColon: '会议号码:',
    StartTimeColon: '开始时间:',
    MeetingDurationColon: '会议时长:',

    Minute: '分钟',
    NowNoPlanMeetingList: '目前没有安排会议列表',
    //broadcastpolling.vue
    BroadcastPoll: '广播轮询',
    PlsEnterPollInterval: '请输入轮询间隔: ',
    Second: '秒',
    TerminalListGetFail: '终端列表获取异常，请刷新页面',
    NetworkException: '网络异常',
    PlsSelectTerminal: '请选择终端！',
    BroadcastPollStartOK: '广播轮询启动成功',
    BroadcastPollStartFail: '广播轮询启动失败',
    //calendar.vue
    MeetingDetails: '会议详情',
    TerminalName: '终端名称:',
    MeetingTime: '会议时间:',
    //MeetingDurationColon: '会议时长:',
    MeetingCreatorColon: '会议创建人:',
    OccupiedResources: '已占用资源:',
    OccupiedSummary: '（占用/总数）',
    Sunday: '星期日',
    Monday: '星期一',
    Tuesday: '星期二',
    Wednesday: '星期三',
    Thursday: '星期四',
    Friday: '星期五',
    Saturday: '星期六',
    //calendarAdd.vue
    ConfirmTerminalSelection: '确认选择终端',
    Year: '年',
    Month: '月',
    Day: '日',
    //OKBtn: '会议名称',终端名称: 会议时间: 会议时长: 会议创建人:
    //OKBtn: '已占用资源:',
    Whichine: '第几行:',
    HowMany: '第几个:',
    //OKBtn: '分钟',
    TerminalAddOK: '终端添加成功',
    TerminalAddFail: '终端添加失败',
    //changemeeting.vue
    ModifyAppointmentMeeting: '修改预约会议',
    PlsEnterMeetingNo: '请输入会议号码',
    //checkinrecord.vue
    CheckinRecord: '签到记录',
    NoCheckinPerson: '无签到人员',
    CheckinNumber: '签到人数:',
    MeetingColon: '会议:',
    UnitColon: '单位:',
    NameColon: '姓名:',
    MobileColon: '手机:',
    EMailColon: '邮箱:',
    CheckinListGetFail: '签到列表获取异常，请刷新页面',
    //departmentListdetail.vue
    Address: '通讯录',
    GetFail: '获取失败',
    AddressGetFail: '通讯录获取异常，请刷新页面',
    //doublestream.vue
    DualStreamFunction: '双流功能',
    PlsenterTerminalName: '请输入终端名称',
    DualStreamSenderOK: '指定双流发送者成功',
    DualStreamSenderFail: '指定双流发送者失败',
    ReuestFail: '请求失败',
    PlsSelectDualTerminal: '请选择双流终端',
    //help.vue
    Help: '帮助',
    //iframe.vue
    VideoOnDemand: '视频点播',
    //index.vue
    ReturnToUnifiedLoginPlatform: '返回统一登录平台',
    AppointManagement: '预约管理',
    ConferenceOnDemand: '会议点播',
    MeetingTemplate: '会议模板',
    TerminalMangerment: '终端管理',
    GoingOn: '正在举行',
    HistoryMeeting: '历史会议',
    ComingSoon : '即将举行',
    HistoryHeld : '历史举行',
    //meetdetail.vue
    VideoAccess: '视频接入',
    ScanQRCodeJionMeeting: '扫二维码入会',
    TelephoneAccess: '电话接入',
    LiveURL: '直播链接',
    ClickToWatchLive: '点击观看直播',
    Password: '密码',
    MeetingSponsor: '会议发起人',
    MeetingBrief: '会议简介',
    MeetingParticipants: '会议参加人员',
    MeetingTerminal: '会议终端',
    MeetingHost: '会议主持',
    CancelMeeting: '取消会议',
    ModifyMeeting: '修改会议',
    ScanterminalQRCodeJionMeeting: '扫终端码入会',
    Return: '返回',
    CloseConfirm: '结束确认',
    ConfirmDeleteMeeting: '确定删除该会议？',
    ClickDownloadTerminalSoftware: '点击下载软件终端',
    GetListFail: '获取列表失败',
    GetBookMeetingListOK: '取消预约会议成功！',
    //meetingact.vue
    Broadcast: '广播',
    InTheMeeting: '会议中',
    PlsInputSearchTerminal : '请输入查询终端',
    AddUser: '增加人员',
    AddTerminal: '增加终端',
    LayoutMode: '分屏模式',
    OneKeyBroadcast: '一键广播',
    AudioControl: '音频控制',
    VideoControl: '视频控制',
    //OKBtn: '双流功能',
    MeetingLock: '会议锁定',
    SaveAsTemplate: '存为模板',
    SaveAs: '存为模板',
    CheckinRecord: '签到记录',
    MeetingEnd: '会议结束',
    //OKBtn: '存为模板',
    LiveShare: '直播分享',
    RecordEnd: '录制结束',
   //OKBtn: '签到记录',会议结束 分屏模式
    SaveBtn: '保存',
    ResumeBtn: '自动分屏',
    SelectBroacastTerminal: '选择广播终端',
    ConfirmCloseMeeting: '确定结束会议？',
    ConfirMDeleteParticipants: '您是否确定删除该与会者？',
    LiveConfirm: '直播确认',
    OpenLiveAndShare: '是否开启直播并分享？',
    Vertical: '垂直',
    Horizontal: '水平',
    Upper: '上部',
    Middle: '中部',
    Bottom: '下部',
    HorizontalUP: '水平上',
    NoRecordDevice: '没有录制设备，此功能不能使用',
    CanceledDualStreamSender: '已取消指定双流发送者',
    CanceledDualStreamSenderFail: '取消指定双流发送者失败',
    RollCallSuccessful : '点名成功',
    RollCallFailed: '点名失败',
    RollCallCancelledSuccessfully : '取消点名成功',
    RollCallCancelledFail: '取消点名失败',
    SetUpTheMainVenueOK: '设置主会场成功',
    SetUpTheMainVenueFail: '设置主会场失败',

    MainVenueCancelledSuccessfully: '取消主会场成功',
    MainVenueCancelledFail: '取消主会场失败',
    BroadcastStatusCanNotSetHost: '当前为广播状态,不能设置主会场',
    PollStatusCanNotSetHost: '当前为轮巡状态,不能设置主会场',
    CallrollCanNotSetHost: '正在点名不能切换主会场',
    NoHostNoCallroll: '未设置主会场，不允许点名',
    CallrollCanNotBroadcast: '当前为点名状态,不能广播',
    PollStatusCanNotBroadcast: '当前为轮巡状态,不能广播',
    OneKeyBroadcastCancelOK: '一键广播取消成功',
    OneKeyBroadcastCancelFail: '一键广播取消失败',
    CancelFail: '取消失败',
    BroadcastOK: '广播成功',
    BroadcastFail: '广播失败',
    ConnectOK: '连接成功',
    ConnectFail: '连接失败',
    DisconnectOK: '断开成功',
    DisconnectFail: '断开失败',
    LayoutOK: '分屏成功',
    LayoutFail: '分屏失败',
    LayoutResumeOK: '分屏恢复成功',
    LayoutResumeFail: '分屏恢复失败',
    SaveTemplateOK: '保存模板成功',
    SaveTemplateFail: '保存模板失败',
    AudioOn: '语音开启',
    AudioOff: '语音关闭',
    AllAudioOn: '全部语音开启',
    AllAudioOff: '全部语音关闭',
    VideoOn: '视频开启',
    VideoOff: '视频关闭',
    AllVideoOn:  '全部视频开启',
    AllVideoOff: '全部视频关闭',
    NoRecordDeviceNoThisFunction: '没有录制设备，此功能不能使用',
    MeetingStartRecord: '会议开始录制',
    MeetingSuspendedRecord: '会议录制暂停',
    MeetingResumeRecord: '会议录制恢复',
    MeetingEndRecord: '会议录制结束',
    MeetingStartLock: '会议开始锁定',
    MeetingStartUnlock: '会议开始解锁',
    MeetingLockFail: '会议锁定失败',
    MeetingUnlockFail: '会议解锁失败',
    DeleteTerminalOK: '删除终端成功',
    CloseMeetingOK: '成功结束该会议！',
    CloseMeetingFail: '结束会议失败',
    NeetingNotice: '会议通知',    
    ReportToJiangsuMonday: '周一汇报江苏',
    ClickConnectJionMeeting: '点击链接入会',
    Minute30: '30分钟',
    //OKBtn: '扫二维码入会',
    NoticeDesc: '本次会议主要是江苏地区的销售，汇总本月的销售计划，并把销售任务完成度和成交额，以及客户需求做主要的分析。',
    //nowmeeting.vue
    HistoryMeetingShort: '历史会议',
    SelectHistoryMeeting: '请选择历史会议',
    //OKBtn: '安排会议',
    //oneclickpolling.vue
    OneKeyPolling: '一键轮询',
    Search: '搜索',    
    PlsSelectTerminal: '请选择终端',
    PlsSelectMainVenue: '请选择主会场',
    PlsSelectLayoutMode: '请选择分屏模式',
    OneKeyPollingStartOK: '一键轮询启动成功',
    OneKeyPollingStartFail: '一键轮询启动失败',
    PollingInterval: '轮询间隔',
    PollingMode: '轮询模式',
    MainVenue: '主会场',
    //peoplechoice.vue
    SelectionOfParticipants: '与会人员选择',
    PlsEnterMeetingNameToSearch: '请输入姓名查询',

    Selectedcolon: '已选:',
    //OKBtn: '姓名:',
    //OKBtn: '单位:',
    //OKBtn: '手机:',
    //OKBtn: '邮箱:',
    AddressGetException: '通讯录获取异常，请刷新页面',
    //personalmode.vue
    SelectMeetingTemplate: '请选择会议模板',
    PersonTemplateGetFail: '个人模板列表获取失败,3秒后跳转新建会议',
    HistoryMeetingListGetFail: '历史会议列表获取失败,3秒后跳转新建会议',
    //OKBtn: '会议名称不能为空',
    //OKBtn: '会议密码格式错误',   
    //roomchoice.vue
    ConferenceRoomSelection : '会议室选择',
    TerminalListGetFail: '终端列表获取失败,请重试',
    //sxt.vue
    SacnQRCode: '扫码',
    PlsConfirmQRCode: '请确认扫描的是正确的二维码',
    CheckinOK: '签到成功！',
    AddTerminalkOK: '增加终端成功！',
    AddterminalFail: '增加终端失败！',
    //terminaladd.vue
    AddTerminal: '添加终端',
    //terminalcontrol.vue
    TerminalMangermentList: '终端管理列表',
    //terminalcontrolPctest.vue
    PlsenterTermnal: '请输入终端',
    //terminaltimeinfo.vue
    TerminaltimeDetail: '终端时间详情',
    //userlist.vue
    Address: '通讯录',
    PlsenterDepartmentConnector: '请输入部门或联系人',
    Selectedcolon: ',已选:',
    Number: '人',
    PlsSelectsharePerson: '请选择分享人员！',
    MeetingShareOK: '会议分享成功',
    MeetingShareFail: '会议分享失败',
    SearchResult: '搜索的结果',
    PlsSelectPerson: '请选择添加人员！',
    PersonAddOK: '人员增加成功',
    PersonAddFail: '人员增加失败',
    //usermessage.vue
    Edit: '编辑',
    PlsClickSelectMobilePicture: '请点击选择手机相册',
    SelectCamoraOrSelectPicture: '或选择相机拍照后再次选择相册上传图片！',
    SaveOK: '保存成功！',
    PlsEnterRightMobileEMail: '请输入正确的手机号和邮箱地址',

    SaveSpace: '保存',
    
    //VVinfo.vue
    VideoConferenceRoomJoin: '视频会议室加入',
    MobileAppJoin: '手机APP加入',
    JoinOK: '加入成功',
    MeetingNoExist: '会议不存在',
    MeetingNoOpen: '会议未召开',
    ParticipantsColon: '参会人员:',
    MeetinghostColon: '会议主持:',
    MeetingPasswordColon: '会议密码:',

    JoinFail: '加入会议失败',
    GetDetailFail: '获取详细信息失败',
    //vvMeetingList.vue
    FormatOneClickEnterMeeting: '方式一:点击以下已预约的信息加入',
    Morning: '上午',
    Afternoon: '下午',
    NoArrangement: '无安排',

    FormatSecondClickEnterMeetingNo: '方式二:输入会议号码加入',
    ClickNextInfoJoin: '点击以下已预约的信息加入',
    GetMeetingListFail: '获取会议列表失败',
    //waitcheck.vue
    PlsImproveTheInformation: '请完善资料并等待管理员审核！',
    UploadOK: '上传成功！',
    UploadFailSendAgain: '上传失败，请重新上传！',    
    ExitSpace: '退出',
    SaveSpace: '保存',
    CancelSpace: '取消',

    ConfirmStopDoubleStream:'是否取消双流发送者权限？',
    MeetingCreated:'创建',
    ModifyFail: '修改失败',
	
    JoiningMeetingURL: '入会链接',
    IntranetJoinURL: '内网入会链接',
    ExternalNetworkURL: '外网入会链接',
    NotAbilityCallOutsideNetworkPleaseContactPolyTechnicalTeamForSupport: '尚不具备外网呼叫能力，请联系Poly技术团队寻求支持！',      
    MeetingNumber: '会议号码',
    TiangongMeetingNumber: '天宫会议号',
    TiangongJoiningConnection: '天宫入会连接',	

  }


// WEBPACK FOOTER //
// ./src/lang/zh-CN.js